// register — or. Part of the or i18n bundle; merged by ./index.js

export default {
  fullName: 'Maqaa Guutuu *',
  email: 'Imeelii',
  phone: 'Bilbila *',
  company: 'Maqaa Dhaabbata',
  businessType: 'Gosa Daldala',
  tin: 'Lakkoofsa TIN',
  elmis: 'Galmee E-LMIS',
  submit: 'Iyyannoo Galchi',
  submitting: 'Galchaa jira...',
  companyToggle: 'Dhaabbata biljimmadhu dirqaa dhaabbataa isa ergaali',
// Register,
  accountDetails: "Bal'ina Herregaa",
  businessInfo: 'Odeeffannoo Daldala',
  nextBusiness: 'Itti aanaa: Odeeffannoo Daldala',
  nextDocs: 'Itti aanaa: Sanadoota',
  businessLicenseReq: 'Lakkoofsa hayyama daldala barbaachisaadha.',
  licenseInfo: '📋 Odeeffannoon kee garee keenya ni madaalama. Galmee booda imeelii siif ergama.',
  phoneLabel2: 'Lakkoofsa Bilbilaa *',
  emailLabel: 'Imeelii (dirqama miti)',
  fullNameLabel: 'Maqaa Guutuu *',
  fillRequired: 'Dirreewwan barbaachisoo hunda guuti.',
  passwordShort: 'Jecha darbii xiqqaate qubee 6 qabaachuu qaba.',
  companyRequired: 'Maqaa dhaabbata barbaachisaadha.',
  phoneLabel: 'Lakkoofsa Bilbilaa',
  passwordLabel: 'Jecha Darbii',
  phoneMustBe9: 'Bilbilni 6 qubee qabaachuu qaba',
  alertFullNameRequired: 'Maqaa guutuu barbaachisaadha',
  alertPhoneDigits: 'Bilbilni 6 qubee qabaachuu qaba (fakkeenyaaf 911031884)',
  alertValidEmail: 'Maaloo teessoo imeelii sirrii galchi',
  alertSubmissionFailed: 'Galchuun hin milkoofne. Maaloo irra deebi\'i yaali.',
  alertCompanyRequired: 'Maqaa dhaabbataa barbaachisaadha.',
  alertTinRequired: 'Lakkoofsa TIN barbaachisaadha.',
  alertElmisRequired: 'Galmee E-LMIS barbaachisaadha.',
  alertBusinessTypeRequired: 'Gosa daldalaa barbaachisaadha.',
// Chat,
  businessTypeLabel: 'Gosa Daldala',
};

